var _defs, _g, _path, _rect, _rect2, _g2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNema515(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;stroke:#353841;stroke-width:1.5px;}.b{fill:#cad0e4;}.c{fill:#71778a;}.d{fill:#353841;}.e{stroke:none;}.f{fill:none;}.g{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 29,
    y: 38,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 74,
    height: 74,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-16476,2854a20.877,20.877,0,0,1-14.854-6.15,21.49,21.49,0,0,1-2.148-2.513v-24.674a21.613,21.613,0,0,1,2.148-2.513A20.876,20.876,0,0,1-16476,2812a21.031,21.031,0,0,1,9.688,2.365,21.153,21.153,0,0,1,7.309,6.3v24.664a21.143,21.143,0,0,1-7.309,6.3A21.031,21.031,0,0,1-16476,2854Z",
    transform: "translate(2870.002 16512.998) rotate(90)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2,
    height: 12,
    rx: 1,
    transform: "translate(28 25)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2,
    height: 12,
    rx: 1,
    transform: "translate(44 25)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5,0H5a5,5,0,0,1,5,5V9a1,1,0,0,1-1,1H1A1,1,0,0,1,0,9V5A5,5,0,0,1,5,0Z",
    transform: "translate(32 41)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3,0H3A3,3,0,0,1,6,3V6A0,0,0,0,1,6,6H0A0,0,0,0,1,0,6V3A3,3,0,0,1,3,0Z",
    transform: "translate(34 43)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNema515);
export default __webpack_public_path__ + "static/media/nema5_15.cae8c480b9080af7553f4b689e75430b.svg";
export { ForwardRef as ReactComponent };